module.exports = __webpack_public_path__ + "img/menu.93da721d.svg";